import axiosInstance from '../axios/axiosInstance';

export const generateQuestionCodes = async (subjectCode: string, numberOfCodes: number | null) => {
  const { data } = await axiosInstance.get<string[]>('auto-codes/question', {
    params: { subjectCode, numberOfCodes },
  });
  return data;
};
